import tgoForm from './tgo-form.vue'

export default tgoForm
